import Image from "next/image";
import { cn } from "utils";
import {
  DIAGNOSIS_FINDING_CARD,
  DIAGNOSIS_FINDING_TAG,
} from "./findingCardTokens";
import type { DiagnosisFindingItem } from "./types";

/**
 * 单条诊断 finding 卡 — 黄底 severity 条 + 毛玻璃正文区。
 * 纯展示，无点击态。
 */
export function DiagnosisFindingCard({
  finding,
}: {
  finding: DiagnosisFindingItem;
}) {
  return (
    <div
      className={cn(
        "flex w-full flex-col overflow-hidden",
        DIAGNOSIS_FINDING_CARD.radiusClass,
      )}
      data-testid={`plan-finding-card-${finding.id}`}
    >
      <div
        className="flex w-full shrink-0 items-center gap-1 px-3 py-1"
        style={{ backgroundColor: DIAGNOSIS_FINDING_TAG.bg }}
      >
        <Image
          src={DIAGNOSIS_FINDING_TAG.iconSrc}
          alt=""
          aria-hidden
          width={16}
          height={16}
          className="shrink-0"
          data-testid="plan-finding-severity-icon"
        />
        <span className={DIAGNOSIS_FINDING_CARD.tagLabelClass}>
          {finding.severityLabel}
        </span>
      </div>
      <div
        data-testid="plan-finding-card-body"
        className="flex w-full shrink-0 flex-col gap-1 p-3"
        style={{
          backgroundColor: DIAGNOSIS_FINDING_CARD.bodyBg,
          backdropFilter: `blur(${DIAGNOSIS_FINDING_CARD.blurPx}px)`,
          WebkitBackdropFilter: `blur(${DIAGNOSIS_FINDING_CARD.blurPx}px)`,
        }}
      >
        <p className={DIAGNOSIS_FINDING_CARD.titleClass}>{finding.title}</p>
        <p className={DIAGNOSIS_FINDING_CARD.descClass}>
          {finding.description}
        </p>
      </div>
    </div>
  );
}

export function DiagnosisFindingCardList({
  findings,
  className,
}: {
  findings: DiagnosisFindingItem[];
  className?: string;
}) {
  return (
    <div
      className={cn("flex flex-col gap-4", className)}
      data-testid="diagnosis-finding-card-list"
    >
      {findings.map((finding) => (
        <DiagnosisFindingCard key={finding.id} finding={finding} />
      ))}
    </div>
  );
}
